__webpack_require__.p = "https://static.spqr.app/52e368f96024da8cffbbbfa255cf208c1996f7ed/_next/";